export interface DashboardSkillsFilter {
  skillResult: string[];
  skillType: string[];
  searchTerm: string;
  onlyTargetSkillsCheckbox: boolean;
  showAllSkillsCheckbox: boolean;
  hideSkillsPassedCheckbox: boolean;
  sortedBy: { value: string; label: string };
}

export interface SelectFilterOption {
  code: number;
  name: string;
}

export const filtersInitialState = {
  skillResult: [],
  skillType: [],
  searchTerm: '',
  onlyTargetSkillsCheckbox: false,
  showAllSkillsCheckbox: false,
  hideSkillsPassedCheckbox: false,
  sortedBy: { value: 'readinessScore', label: 'Most ready for' },
};
